import { getUserInfo, cacheUserInfo } from '@/utils/authorized'
import api from '@/utils/api'
import qs from 'qs'

export default {
  wxShare ({ appId, timestamp, nonceStr, signature, options={} }, next = () => {}) {
    console.log('wxShare -> ', options)
    if (!/micromessenger/i.test(navigator.userAgent)) {
      next(true)
      return
    }
    wx.config({
      debug: false,
      appId,
      timestamp,
      nonceStr,
      signature,
      jsApiList: [
        // 所有要调用的 API 都要加到这个列表中
        'updateAppMessageShareData',
        'updateTimelineShareData',
        'checkJsApi',
        'onMenuShareTimeline',
        'onMenuShareAppMessage',
        'onMenuShareQQ',
        'onMenuShareWeibo',
        'onMenuShareQZone',
        'hideMenuItems',
        'showMenuItems',
        'hideAllNonBaseMenuItem',
        'showAllNonBaseMenuItem',
      ]
    })
    wx.ready(function () {   //需在用户可能点击分享按钮前就先调用

      wx.updateAppMessageShareData({ 
        ...options
      });
      wx.updateTimelineShareData({ 
        ...options
      })
    });
  },
  initWxLocation ({ appId, timestamp, nonceStr, signature }, next) {
    if (!/micromessenger/i.test(navigator.userAgent)) {
      next(true)
      return
    }
    wx.config({
      debug: false,
      appId,
      timestamp,
      nonceStr,
      signature,
      jsApiList: [
        // 所有要调用的 API 都要加到这个列表中
        'getLocation'
      ]
    })
    wx.ready(function () {
      wx.checkJsApi({
        jsApiList: [
          'getLocation'
        ],
        success: function (res) {
          // alert(JSON.stringify(res));
          //alert(JSON.stringify(res.checkResult.getLocation));
          if (res.checkResult.getLocation == false) {
            alert('你的微信版本太低，不支持微信JS接口，请升级到最新的微信版本！')
          }
        }
      })
      wx.error(function (res) {
        // alert('微信接口失败，')
        function getLocation () {
              // var key = '2CTBZ-YZ3CX-LOG4W-T4X7X-AJ4S6-C3F6J'
              var geolocation = new qq.maps.Geolocation('4LFBZ-C6VR4-UJLUP-XDWVV-5PFWJ-QCB3D','eccs');
              geolocation.getLocation(function(rs){
                // 成功回调
                window._wxLocation = {
                  latitude: rs.lat,
                  longitude: rs.lng,
                  accuracy: 0
                }
                cacheUserInfo({
                  ...getUserInfo(),
                  ...window._wxLocation
                })
                // alert('腾讯定位成功')
                // this.search()
                next(false)
              },function (rs){
                // 失败回调
                // alert('腾讯定位失败')
                // this.search()
                next(true)
              })
        }
        getLocation()
        
      })
      wx.getLocation({
        success: function (res) {
          // alert('微信定位成功')
          let latitude = res.latitude // 纬度，浮点数，范围为90 ~ -90
          let longitude = res.longitude // 经度，浮点数，范围为180 ~ -180。
          /* speed = res.speed; // 速度，以米/每秒计     */
          let accuracy = res.accuracy // 位置精度
          window._wxLocation = {
            latitude,
            longitude,
            accuracy
          }
          cacheUserInfo({
            ...getUserInfo(),
            ...window._wxLocation
          })
          next(false)
        },
        fail:function(res){
          // alert('微信定位失败')
          function getLocation () {
            var geolocation = new qq.maps.Geolocation('4LFBZ-C6VR4-UJLUP-XDWVV-5PFWJ-QCB3D','eccs');
            geolocation.getLocation(function(rs){
              // 成功回调
              // alert('腾讯定位成功')
              window._wxLocation = {
                latitude: rs.lat,
                longitude: rs.lng,
                accuracy: 0
              }
              next(false)
            },function (rs){
              // 失败回调
              // alert('腾讯定位失败')
              next(true)
            })
          }
          getLocation()
        },
        cancel: function (res) {
          next(true)
          // alert('用户拒绝授权获取地理位置')
        }
      })
    })
  },
  fetchJsSdkSign (callMethodName, options = {}, callback) {
    const url = location.href.split('#')[0]
    // alert('获取签名url ->' + url)
    const apiMethod = callMethodName ? 'getWxShareSign' : 'getJsJdkSign';
    let formData = new FormData();
    formData.append('url', url);
    formData.append('shareUrl', url);
    api[apiMethod](formData).then(res => res.data).then(data => {
      const { appId, jssdkReqData } = data
      const params = {
        appId: appId,
        nonceStr: jssdkReqData.noncestr,
        timestamp: jssdkReqData.timestamp,
        signature: jssdkReqData.signature,
        options
      }
      if (callMethodName && typeof callMethodName == 'string') {
        // 分享或者...
        this[callMethodName](params);
        callback && callback()
        return
      }
      this.initWxLocation(params, (error, errDetail) => {
        if (error===true) {
          // errDetail && alert('获取定位失败，请稍后再试，原因：' + errDetail.errMsg + '参数：' + qs.stringify(params))
          this.locFail = true
        } else {
          this.locFail = false
        }
        this.checkAddressData(true)
      })
    })
  }
}
